import usePageErrorState from 'hooks/stateHooks/usePageErrorState';
import useRolePermissions from 'hooks/stateHooks/useRolePermissions';
import useTeamsState from 'hooks/stateHooks/useTeamsState';
import { lazy } from 'react';

const Error401 = lazy(() => import('component/base/PageError/Error401'));

const Error404 = lazy(() => import('component/base/PageError/Error404'));

const Error404Teams = lazy(
  () => import('component/base/PageError/Error404Teams'),
);

/**
 * Provides an error component to render in the case
 * of a page Error.
 *
 * TODOS:
 *  - Error404Teams only ever used in NoLayout component.
 *    Oversight? If not - provide a prop.
 *  - Error404Teams currently only used in teams Tab.
 *    Use in personal static tab?
 */
const useContentError = () => {
  const { hasRolePermissions } = useRolePermissions();
  const { error401, error404 } = usePageErrorState();
  const { inTeamsChannelTab } = useTeamsState();

  if (error401.value || !hasRolePermissions) {
    return Error401;
  }

  if (error404.value && inTeamsChannelTab) {
    return Error404Teams;
  }

  if (error404.value) {
    return Error404;
  }

  return null;
};

export default useContentError;
